var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showLoad)?_c('div',{staticStyle:{"z-index":"99999"},attrs:{"id":"loader-container"}},[_c('LoroPianaLogo',{staticClass:"col-md-3 col-md-offset-4_5 col-sm-6 col-sm-offset-3 col-xs-8 col-xs-offset-2 loader-logo"})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-695fd422","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/global/loader/components/Loader.vue
// module id = null
// module chunks = 